import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useIntl, defineMessages } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';

import { logEvent, Event } from '../../../lib/analytics';
import getRouteFor, { Route } from '../../../lib/utils/router';
import { IconHome, IconHomeSelected } from '../../IconSet';


const messages = defineMessages({
  gotoHome: { id: 'gotoHomepage' },
});


function Home(props: RouteComponentProps) {
  const { formatMessage } = useIntl();

  const homePath = getRouteFor(Route.Home);

  const gotoHome = React.useCallback(
    () => {
      if (props.location.pathname !== homePath) {
        props.history.push(homePath);
        logEvent(Event.HOME);
      }
    },
    [props.history, props.location, homePath]
  );

  const pathName = props.location.pathname;
  const getIcon = () => {
    return (
      <React.Fragment>
        {pathName === Route.Home
          ? <IconHomeSelected size={32} />
          : <IconHome size={32} />}
      </React.Fragment>
    );
  };

  const getMobileLayout = () => {
    return (
      <MenuItem onClick={gotoHome}>
        <ListItemIcon>
          {getIcon()}
        </ListItemIcon>
        <ListItemText primary={formatMessage(messages.gotoHome)} />
      </MenuItem>
    );
  };

  const getLayout = () => {
    return (
      <Tooltip title={formatMessage(messages.gotoHome)}>
        <IconButton onClick={gotoHome}>
          {getIcon()}
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <React.Fragment>
      { isMobileOnly ? getMobileLayout() : getLayout()}
    </React.Fragment>
  );
}


export default withRouter(Home);
